<section class="integrations-section py-5">
  <div class="container">
    <div class="row text-center section-header-row">
      <div class="col-12">
        <h2 class="section-title">Works with the tools you already use</h2>
        <p class="section-subtitle">Connect MemberTrace with payment, file, and workspace tools today, with more connectors planned.</p>
      </div>
    </div>

    <h3 class="integration-group-title">Live now</h3>
    <div class="row g-4 justify-content-center">
      <div class="col-6 col-md-4 col-lg" *ngFor="let integration of liveIntegrations; trackBy: integrationTrackBy">
        <div class="integration-card h-100">
          <img [src]="integration.logo" [alt]="integration.name" class="integration-logo" />
          <span class="integration-name">{{ integration.name }}</span>
        </div>
      </div>
    </div>

    <h3 class="integration-group-title planned-title">Planned</h3>
    <div class="row g-4 justify-content-center">
      <div class="col-6 col-md-4 col-lg-3" *ngFor="let integration of plannedIntegrations; trackBy: integrationTrackBy">
        <div class="integration-card integration-card-planned h-100">
          <img [src]="integration.logo" [alt]="integration.name" class="integration-logo" />
          <span class="integration-name">{{ integration.name }}</span>
          <span class="coming-soon-tag">Coming soon</span>
        </div>
      </div>
    </div>
  </div>
</section>
